import axios from 'axios';
import config from '../config/api.json';
const { API_URL, API_VERSION, API_KEY, CORE_KEY } = config;

function getObj(objectName) {
  switch (objectName) {
    case "App":
      return `App { 
        ... on object_App { 
          id name subTitle url target icon isActive permission
          logo { fullpath filename mimetype }
          ${getObj("Credentials")}
        } 
      }`;
    case "AppFolder":
      return `AppFolder { 
        ... on object_AppFolder { 
          id name
        } 
      }`;
    case "Carrier":
      return `Carrier { 
        ... on object_Carrier { 
          id name color codeColor code 
          logo { fullpath filename mimetype } 
        } 
      }`;
    case "Company":
      return `Company { 
        ... on object_Company { 
          id name vatNumber dataID
          logo { fullpath filename mimetype } 
          ${getObj("CompanyOffice")}
        } 
      }`;
    case "CompanyOffice":
      return `Office { 
        ... on object_CompanyOffice { 
          id name address city phone email pdvName 
        } 
      }`;
    case "Contact":
      return `Contact { 
        ... on object_Contact { 
          id firstName lastName companyName phone email description whatsapp fiscalCode note
        } 
      }`;
    case "ContactHistory":
      return `ContactHistory { 
        ... on object_ContactHistory { 
          id date note outcome
          ${getObj("Contact")}
          ${getObj("User")}
        } 
      }`;
    case "Credentials":
      return `Credentials { 
        ... on object_Credentials { 
          id name username password 
        } 
      }`;
    case "OTC":
      return `OTC { 
        ... on object_OTC { 
          id name val default 
          logo { fullpath filename mimetype } 
        } 
      }`;
    case "Order":
      return `Order { 
        ... on object_Order { 
          id num date 
        } 
      }`;
    case "OrderItem":
      return `OrderItem { 
        ... on object_OrderItem { 
          id description trackingNumber trackingLink quantity price percent delivered collected
          ${getObj("Order")}
        } 
      }`;
    case "Person":
      return `Person { 
        ... on object_Person { 
          id firstName lastName fiscalCode address phone1 phone2 email
        } 
      }`;
    case "Project":
      return `Project { 
        ... on object_Project { 
          id name 
        } 
      }`;
    case "QualityAnswer":
      return `QualityAnswer { 
        ... on object_QualityAnswer { 
          id answer rating 
          ${getObj("QualityQuestion")}
        } 
      }`;
    case "QualityClose":
      return `QualityClose { 
        ... on object_QualityClose { 
          id title close 
        } 
      }`;
    case "QualityOpen":
      return `QualityOpen { 
        ... on object_QualityOpen { 
          id title open 
        } 
      }`;
    case "QualityQuestion":
      return `QualityQuestion { 
        ... on object_QualityQuestion { 
          id question description
        } 
      }`;
    case "Setting":
      return `Setting { 
        ... on object_Setting { 
          id name qty val isBar
        } 
      }`;
    case "Shift":
      return `Shift { 
        ... on object_Shift { 
          id timestamp
          ${getObj("ShiftType")}
          ${getObj("User")}
        } 
      }`;
    case "ShiftClosure":
      return `ShiftClosure { 
        ... on object_ShiftClosure { 
          id date
        } 
      }`;
    case "ShiftType":
      return `ShiftType { 
        ... on object_ShiftType { 
          id name icon color permission
        } 
      }`;
    case "ShiftUser":
      return `ShiftUser { 
        ... on object_ShiftUser { 
          id 
          ${getObj("CompanyOffice")}
          ${getObj("User")}
        } 
      }`;
    case "Sim":
      return `Sim { 
        ... on object_Sim { 
          id label name size
        } 
      }`;
    case "Target":
      return `Target { 
        ... on object_Target { 
          id name promo fee points tempText isTemp visible
          ${getObj("Carrier")}
          ${getObj("OTC")}
          ${getObj("TargetType")}
          ${getObj("TargetType_points")}
        } 
      }`;
    case "TargetCategory":
      return `TargetCategory { 
        ... on object_TargetCategory { 
          id name 
        } 
      }`;
    case "TargetGroup":
      return `TargetGroup { 
        ... on object_TargetGroup { 
          id master name label val
          ${getObj("TargetType")}
        } 
      }`;
    case "TargetItem":
      return `TargetItem { 
        ... on object_TargetItem { 
          id date unlocked status feedback evaluation dateNotification
          ${getObj("Contact")}
          ${getObj("Target")}
          ${getObj("User")}
          ${getObj("User_coop")}
        } 
      }`;
    case "TargetName":
      return `TargetName { 
        ... on object_TargetName { 
          id name share
          ${getObj("Carrier")}
        } 
      }`;
    case "TargetPoint":
      return `TargetPoint { 
        ... on object_TargetPoint { 
          id points
          ${getObj("TargetGroup")}
        } 
      }`;
    case "TargetPromo":
      return `TargetPromo { 
        ... on object_TargetPromo { 
          id name
          ${getObj("Carrier")}
          ${getObj("TargetType")}
        } 
      }`;
    case "TargetSetting":
      return `TargetSetting { 
        ... on object_TargetSetting { 
          id month minOTC extraOTC tgtOTC
        } 
      }`;
    case "TargetThreshold":
      return `TargetThreshold { 
        ... on object_TargetThreshold { 
          id step minimumValue amount isBonus
        } 
      }`;
    case "TargetType":
      return `TargetType { 
        ... on object_TargetType { 
          id name icon isStats
          logo { fullpath filename mimetype }
        } 
      }`;
    case "TargetType_points":
      return `TargetType_points { 
        ... on object_TargetType { 
          id name icon isStats
          logo { fullpath filename mimetype }
        } 
      }`;
    case "User":
      return `User { 
        ... on object_User { 
          id username role percentage token
          avatar { fullpath filename mimetype }
          ${getObj("Project")}
          ${getObj("Person")}
          ${getObj("Company")}
        } 
      }`;
    case "User_coop":
      return `User_coop { 
        ... on object_User { 
          id username role percentage token
          avatar { fullpath filename mimetype }
          ${getObj("Project")}
          ${getObj("Person")}
          ${getObj("Company")}
        } 
      }`;
    case "Video":
      return `Video { 
        ... on object_Video { 
          id title link isMandatory date
          ${getObj("Carrier")}
          ${getObj("User")}
        } 
      }`;
  }
  return;
}

async function request(data) {
  const isProduction = process.env.NODE_ENV === 'production';
  const url = isProduction
    ? "https://core.dixxip.com/pimcore-graphql-webservices/dixcore"
    : "/pimcore-graphql-webservices/dixcore";
  try {
    const response = await axios.post(
      url, data,
      {
        headers: {
          'X-API-Key': CORE_KEY,
          'Content-Type': 'application/json'
        }
      }
    );
    return response;
  } catch (error) {
    return { message: "Error communicating with the server.", type: "error" };
  }
}

// Il timestamp è la chiave dell'elemento: deve essere strettamente crescente anche per chiamate concorrenti
let lastTargetItemTimestamp = 0;
const getUniqueTimestamp = () => {
  lastTargetItemTimestamp = Math.max(Date.now(), lastTargetItemTimestamp + 1);
  return lastTargetItemTimestamp;
};

// Ottieni l'IP pubblico
const ipRes = await axios.get('https://api.ipify.org?format=json');
const myIP = ipRes.data.ip;

// #region CREATE API 
export const addTargetCard = async (formdata, master, month) => {
  const parentID = await getParentID("AppFolder", `%Reboot/+${master}/Rewards/+Targets/%`, month);
  let data = JSON.stringify({
    query: `mutation createTarget (
      $name: String!
      $promo: String!
      $tempText: String!
    ) {
      createTarget(
      parentId: ${parentID}, 
      key: "${formdata.name}", 
      published: true,
      input: {
        name: $name
        promo: $promo
        fee: ${formdata.fee}
        points: "${formdata.points}"
        isTemp: ${formdata.isTemp}
        tempText: $tempText
        visible: ${formdata.visible}
        Carrier: [{id: ${formdata.Carrier}}]
        OTC: [{id: ${formdata.OTC}}]
        TargetType: [{id: ${formdata.TargetType}}]
        TargetType_points: [${formdata.TargetType_points.map((point) => `{id: ${point}}`).join(",")}]
      }) {
        success
        message
        output(defaultLanguage: "en") {
          id      
        }
      }
    }`,
    variables: {
      name: String(formdata.name),
      promo: String(formdata.promo),
      tempText: String(formdata.tempText)
    }
  });
  return await request(data);
};

export const addContactHistory = async (formdata) => {
  const timestamp = Date.now();
  let data = JSON.stringify({
    query: `mutation CreateContactHistory(
      $note: String!
    ) {
      createContactHistory(
        parentId: ${formdata.Contact}, 
        key: "${timestamp}", 
        published: true,
        input: {
          Contact: [{id: ${formdata.Contact}}]
          User: [{id: ${formdata.User}}]
          date: "${formdata.date}"
          note: $note
          outcome: ${formdata.outcome}
        }
      ) {
        success
        message
        output(defaultLanguage: "en") {
          id 
        }
      }
    }`,
    variables: {
      note: String(formdata.note)
    }
  });
  return await request(data);
};

export const addQualityAnswer = async (formdata, master, parentID) => {
  const timestamp = Date.now();
  let data = JSON.stringify({
    query: `mutation QualityAnswer(
      $answer: String!
    ) {
      createQualityAnswer(
        parentId: ${parentID}, 
        key: "${timestamp}", 
        published: true,
        input: {
          QualityQuestion: [{id: ${formdata.QualityQuestion}}]
          answer: $answer
          rating: ${formdata.rating}
        }
      ) {
        success
        message
        output(defaultLanguage: "en") {
          id 
        }
      }
    }`,
    variables: {
      answer: String(formdata.answer)
    }
  });
  return await request(data);
};

export const addStatusHistory = async (formdata) => {
  const timestamp = Date.now();
  let data = JSON.stringify({
    query: `mutation CreateTargetStatus(
      $note: String!
    ) {
      createTargetStatus(
        parentId: ${formdata.TargetItem}, 
        key: "${timestamp}", 
        published: true,
        input: {
          TargetItem: [{id: ${formdata.TargetItem}}]
          User: [{id: ${formdata.User}}]
          date: "${formdata.date}"
          note: $note
          outcome: ${formdata.outcome}
        }
      ) {
        success
        message
        output(defaultLanguage: "en") {
          id 
        }
      }
    }`,
    variables: {
      note: String(formdata.note)
    }
  });
  return await request(data).then(() => updateTargetItemStatus(formdata.TargetItem, formdata.outcome));
};

export const addBookmark = async (parentID, formdata) => {
  try {
    const timestamp = Date.now();
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/create/App/${parentID}/${timestamp}`,
      formdata, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error adding bookmark:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const addCredentials = async (parentID, formdata) => {
  try {
    const timestamp = Date.now();
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/create/Credentials/${parentID}/${timestamp}`,
      formdata, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error adding credentials:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const addShiftClosure = async (formdata, master, month) => {
  try {
    const parentID = await getParentID("AppFolder", `%Reboot/+${master}/Turni/${month}/%`, `+closures`);
    const timestamp = Date.now();
    var response = await axios.post(`${API_URL}/${API_VERSION}/core/create/ShiftClosure/${parentID}/${timestamp}`,
      formdata, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });
    return response;
  } catch (error) {
    console.error("Error adding shift closure:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const addShift = async (formdata, master, month, id = null) => {
  try {
    if (!id) {
      const parentID = await getParentID("AppFolder", `%Reboot/+${master}/Turni/%`, `${month}`);
      const timestamp = Date.now();
      var response = await axios.post(`${API_URL}/${API_VERSION}/core/create/Shift/${parentID}/${timestamp}`,
        formdata, {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
      });
    } else {
      var response = await axios.post(`${API_URL}/${API_VERSION}/core/update/Shift/${id}`,
        formdata, {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
      });
    }
    return response;
  } catch (error) {
    console.error("Error adding shift:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const addTargetItem = async (formdata, master) => {
  try {
    const timestamp = getUniqueTimestamp();
    const parentID = await getParentID("AppFolder", `%Reboot/+${master}/Rewards/%`, "+TargetItems");
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/create/TargetItem/${parentID}/${timestamp}`,
      formdata, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });
    return response;
  } catch (error) {
    console.error("Error adding target item:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const addContact = async (formdata, master) => {
  try {
    const parentID = await getParentID("AppFolder", `%Reboot/+${master}/Account/%`, "+Contacts");
    const timestamp = Date.now();
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/create/Contact/${parentID}/${timestamp}`,
      formdata, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error adding contact:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};
// #endregion CREATE API

// #region READ API 
export const getAdminApps = async (master) => {
  let data = JSON.stringify({
    query: `{
      getAppListing(
        sortBy: "name",
        sortOrder: "ASC",
        filter: "{\\\"path\\\": {\\\"$like\\\" :\\\"%/Projects/Reboot/+${master}%\\\"}, \\\"isActive\\\": {\\\"$like\\\" :\\\"2\\\"}}"
        ) {
        edges {
          node {
            id name subTitle url target icon isActive permission
            logo { fullpath filename mimetype }
            ${getObj("Credentials")}
          }
        }
      }
    }`
  });
  return await request(data);
};

export const getApps = async (master) => {
  let data = JSON.stringify({
    query: `{
      getAppListing(
        sortBy: "name",
        sortOrder: "ASC",
        filter: "{\\\"path\\\": {\\\"$like\\\" :\\\"%/Projects/Reboot/+${master}%\\\"}, \\\"isActive\\\": {\\\"$like\\\" :\\\"1\\\"}}"
        ) {
        edges {
          node {
            id name subTitle url target icon isActive permission
            logo { fullpath filename mimetype }
            ${getObj("Credentials")}
          }
        }
      }
    }`
  });
  return await request(data);
};

export const getGodApps = async (master) => {
  let data = JSON.stringify({
    query: `{
      getAppListing(
        sortBy: "name",
        sortOrder: "ASC",
        filter: "{\\\"path\\\": {\\\"$like\\\" :\\\"%/Projects/Reboot/+${master}%\\\"}, \\\"isActive\\\": {\\\"$like\\\" :\\\"3\\\"}}"
        ) {
        edges {
          node {
            id name subTitle url target icon isActive permission
            logo { fullpath filename mimetype }
            ${getObj("Credentials")}
          }
        }
      }
    }`
  });
  return await request(data);
};

export const getParentID = async (objectName, path, parentName) => {
  let data = JSON.stringify({
    query: `{
      get${objectName}Listing(
        sortBy: "id",
        sortOrder: "ASC",
        filter: "{\\\"path\\\": {\\\"$like\\\" :\\\"%${path}%\\\"}, \\\"name\\\": {\\\"$like\\\" :\\\"${parentName}\\\"}}"
        ) {
        edges {
          node {
            id 
          }
        }
      }
    }`
  });
  return await request(data).then(response => response.data.data[`get${objectName}Listing`].edges[0]?.node?.id);
};

export const getSettings = async (master, path, month = "") => {
  let data = JSON.stringify({
    query: `{
      getSettingListing(
        sortBy: "val",
        sortOrder: "ASC",
        filter: "{\\\"path\\\": {\\\"$like\\\" :\\\"%/Projects/Reboot/+${master}/Settings/+${path}/${month}%\\\"}}"
        ) {
        edges {
          node {
            id name qty val isBar
          }
        }
      }
    }`
  });
  return await request(data);
};

export const getTargets = async (master, fee, OTC, month, targetID = "") => {
  let data = JSON.stringify({
    query: `{
      getTargetListing(
        sortBy: "name",
        sortOrder: "ASC",
        filter: "{\\\"path\\\": {\\\"$like\\\" :\\\"%/Projects/Reboot/+${master}/Rewards/+Targets/${month}%\\\"}, \\\"visible\\\": {\\\"$like\\\" :\\\"1\\\"}, \\\"id\\\": {\\\"$like\\\" :\\\"%${targetID}%\\\"}}"
        ) {
        edges {
          node {
            id name promo fee points tempText isTemp visible
            ${getObj("Carrier")}
            ${getObj("OTC")}
            ${getObj("TargetType")}
            ${getObj("TargetType_points")}
          }
        }
      }
    }`
  });
  return await request(data);
};

export const getTargetByID = async (id) => {
  let data = JSON.stringify({
    query: `{
      getTargetItemListing(
        sortBy: ["date","id"],
        sortOrder: "DESC",
        filter: "{\\\"id\\\": {\\\"$like\\\" :\\\"${id}\\\"}}"
        ) {
        totalCount
        edges {
          node {
            id date unlocked status check feedback evaluation dateNotification
            ${getObj("Contact")}
            ${getObj("Target")}
            ${getObj("User")}
            ${getObj("User_coop")}
          }
        }
      }
    }`
  });
  return await request(data);
};

export const getTargetItems = async (master, first, after, date, userID = "", role = "") => {
  let data = JSON.stringify({
    query: `{
      getTargetItemListing(
        sortBy: ["date","id"],
        sortOrder: "DESC",
        first: ${first}, after: ${after},
        filter: "{\\\"path\\\": {\\\"$like\\\" :\\\"%/Projects/Reboot/+${master}/Rewards/+TargetItems%\\\"}, \\\"date\\\": {\\\"$like\\\" :\\\"%${date}%\\\"}, \\\"User\\\": {\\\"$like\\\" :\\\"%${userID}%\\\"}}"
        ) {
        totalCount
        edges {
          node {
            id date unlocked status check feedback evaluation dateNotification
            ${getObj("Contact")}
            ${getObj("Target")}
            ${getObj("User")}
            ${getObj("User_coop")}
          }
        }
      }
    }`
  });
  return await request(data);
};

export const getTargetSettings = async (master, month) => {
  let data = JSON.stringify({
    query: `{
      getTargetSettingListing(
        sortBy: "month",
        sortOrder: "ASC",
        filter: "{\\\"path\\\": {\\\"$like\\\" :\\\"%/Projects/Reboot/+${master}/Rewards/+TargetSettings%\\\"}, \\\"month\\\": {\\\"$like\\\" :\\\"%${month}%\\\"}}"
        ) {
        edges {
          node {
            id month minOTC extraOTC tgtOTC
          }
        }
      }
    }`
  });
  return await request(data);
};

export const getCheckAnswers = async (master, parentID) => {
  let data = JSON.stringify({
    query: `{
      getQualityAnswerListing(
        sortBy: "id",
        sortOrder: "ASC",
        filter: "{\\\"parentID\\\": {\\\"$like\\\" :\\\"${parentID}\\\"}, \\\"rating\\\": {\\\"$like\\\" :\\\"0\\\"}}"
        ) {
        edges {
          node {
            id answer rating
            ${getObj("QualityQuestion")}
          }
        }
      }
    }`
  });
  return await request(data);
};

export const getQualityAnswers = async (master, parentID) => {
  let data = JSON.stringify({
    query: `{
      getQualityAnswerListing(
        sortBy: "id",
        sortOrder: "ASC",
        filter: "{\\\"parentID\\\": {\\\"$like\\\" :\\\"${parentID}\\\"}, \\\"rating\\\": {\\\"$gt\\\" :\\\"0\\\"}}"
        ) {
        edges {
          node {
            id answer rating
            ${getObj("QualityQuestion")}
          }
        }
      }
    }`
  });
  return await request(data);
};

export const getUser = async (username) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/User/id,username,avatar,role/path:%25Users%25,username:${username}/username:ASC/1:0/totalCount:0/Person:address;email;phone1,Company:dataID,Project:name`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching user:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getCurrency = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/OTC/id,name,logo,val,default/path:%25Reboot%2F+${master}%2FBank%25,default:1/name:ASC/1:0/totalCount:0`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching currency:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getVideos = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/Video/id,title,link,isMandatory,date/path:%25Reboot%2F+${master}%2FAcademy%2F/date:DESC/1000:0/totalCount:1/Carrier:name;logo`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching videos:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getShiftUsers = async (master, month) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/ShiftUser/id/path:%25Reboot%2F+${master}%2FTurni%2F${month}%25/CompanyOffice,key:ASC/100:0/totalCount:1/User:id;username;avatar,CompanyOffice:name`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getShiftTypes = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/ShiftType/id,name,icon,color,permission/path:%25Reboot%2F+${master}%2FTurni%2F+ShiftTypes%25/color,name:ASC/100:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching types:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getShiftClosures = async (master, month) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/ShiftClosure/id,date/path:%25Reboot%2F+${master}%2FTurni%2F${month}%2F+closures%25/date:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching shift closures:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getShifts = async (master, month) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/Shift/id,timestamp/path:%25Reboot%2F+${master}%2FTurni%2F${month}%25/id:DESC/1000000:0/totalCount:1/User:id,ShiftType:id;name;icon;color`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching shifts:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getUsers = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/User/id,username,percentage/path:%25Users%2F+${master}%2FSellers%25/username:ASC/100:0/totalCount:1/Person:firstName`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching users:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getHeaderBar = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/Setting/name,val,isBar/path:%25Reboot%2F+${master}%2FSettings%25,isBar:1/name:ASC/100:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });
    return response;
  } catch (error) {
    console.error("Error fetching header bar:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getContacts = async (fiscalCode, master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/Contact/id,firstName,lastName,phone,fiscalCode,companyName/path:%25Reboot%2F+${master}%2FAccount%2F+Contacts%25,fiscalCode:${fiscalCode}/lastName:ASC/100:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching contacts:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getContactsList = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/Contact/id,firstName,lastName,phone,email,whatsapp,description/path:%25+${master}%2FRubrica%25/lastName:ASC/100:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching contacts list:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getStatusHistory = async (targetItemID, limit = 100) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/TargetStatus/id,date,note,outcome/parentID:${targetItemID}/date,id:DESC/${limit}:0/totalCount:1/User:username`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching status history:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getContactHistory = async (contactID) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/ContactHistory/id,date,note,outcome/parentID:${contactID}/date,id:DESC/100:0/totalCount:1/User:username`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching contact history:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getTargetItemsKO = async (master, date) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/TargetItem/id,date,unlocked,status/path:%25Reboot%2F+${master}%2FRewards%2F+TargetItems%25,date:%25${date}%25,status:2/date:DESC/1000000:0/totalCount:1/Target:name fee,User:username,Contact:firstName lastName phone`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching target items KO:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getTargetNames = async (master, date) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/TargetName/id,name,share/path:%25Reboot%2F+${master}%2FStatistiche%2F${date}%25/name:ASC/1000000:0/totalCount:1/Carrier:name color codeColor;logo`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching target names:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getTargetGroups = async (master, date, target) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/TargetGroup/id,name,master,label,val,fullpath/path:%25Reboot%2F+${master}%2FStatistiche%2F${date}%2F${target}%25/label:ASC/1000000:0/totalCount:1/TargetType:name;icon`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    response.data.data.getTargetGroupListing.edges.forEach(async edge => {
      const targetName = edge.node.fullpath.split('/')[6];
      const groupName = edge.node.fullpath.split('/')[7];
      edge.node.TargetThreshold = [];

      edge.node.targetName = targetName;

      const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/TargetThreshold/id,step,minimumValue,amount,isBonus/path:%25Reboot%2F+${master}%2FStatistiche%2F${date}%2F${targetName}%2F${groupName}%25/step:ASC/1000000:0/totalCount:1/`,
        { myIP }, {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
      });
      response.data.data.getTargetThresholdListing.edges.forEach(async threshold => {
        edge.node.TargetThreshold.push(threshold.node);
      });
    });

    return response;
  } catch (error) {
    console.error("Error fetching target groups:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getTargetTypes = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/TargetType/id,name,isStats,icon/path:%25Reboot%2F+${master}%2FRewards%2F+TargetTypes%25/name:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching target types:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getCarriers = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/Carrier/id,name,code,logo/path:%25Reboot%2F+${master}%2F+Carriers%25/name:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching carriers:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};



export const getSIMsList = async () => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/Sim/id,name,size,label/path:%25Reboot%2FSIMs%25/label:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching SIMs list:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getBookmarks = async (master, parentID = null) => {
  try {
    if (!parentID) {
      parentID = await getParentID("App", `%Reboot/+${master}`, "Link utili");
    }
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/App/id,name,subTitle,url,icon,target,logo,permission/parentID:${parentID}/name,subTitle:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching bookmarks:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getCompanyOffices = async (master, parentID = null) => {
  try {
    if (!parentID) {
      parentID = await getParentID("AppFolder", `%Reboot/+${master}`, "+Offices");
    }
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/CompanyOffice/id,name/parentID:${parentID}/id:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching offices:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getAssetsIdByPath = async (path) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listingAssets/path:${path}/filename:ASC`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching assets by path:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getCheckOpen = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/QualityOpen/id,title,open/path:%25Reboot%2F+${master}%2FAccount%2F+CheckQuestions%25/title:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching check open data:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getQualityOpen = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/QualityOpen/id,title,open/path:%25Reboot%2F+${master}%2FAccount%2F+QualityQuestions%25/title:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching quality open data:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getQualityClose = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/QualityClose/id,title,close/path:%25Reboot%2F+${master}%2FAccount%2F+QualityQuestions%25/title:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching quality close data:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getCheckClose = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/QualityClose/id,title,close/path:%25Reboot%2F+${master}%2FAccount%2F+CheckQuestions%25/title:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching quality close data:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getCheckQuestions = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/QualityQuestion/id,description,question/path:%25Reboot%2F+${master}%2FAccount%2F+CheckQuestions%25/question:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching check questions data:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getQualityQuestions = async (master) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/QualityQuestion/id,description,question/path:%25Reboot%2F+${master}%2FAccount%2F+QualityQuestions%25/question:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching quality questions data:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getCredentials = async (master, parentID = null) => {
  try {
    if (!parentID) {
      parentID = await getParentID("App", `%Reboot/+${master}`, "Credenziali");
    }
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/Credentials/id,name,username,password/parentID:${parentID}/name:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching credentials:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const getCompanies = async () => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/listing/Company/id,name,logo,dataID/path:%25Companies%25/name:ASC/1000000:0/totalCount:1`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching companies:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};
// #endregion READ API

// #region UPDATE API 
export const saveCheckStatus = async (id, formdata) => {
  let data = JSON.stringify({
    query: `mutation {
      updateTargetItem(
      id: ${id}, 
      input: {
        check: ${formdata.check}
      }) {
        success
        message
        output(defaultLanguage: "en") {
          id      
        }
      }
    }`
  });
  return await request(data);
};

export const saveQualityFeedback = async (id, formdata) => {
  let data = JSON.stringify({
    query: `mutation updateTargetItem (
      $feedback: String!
    ) {
      updateTargetItem(
      id: ${id}, 
      input: {
        feedback: $feedback
        evaluation: ${formdata.evaluation}
      }) {
        success
        message
        output(defaultLanguage: "en") {
          id      
        }
      }
    }`,
    variables: {
      feedback: String(formdata.feedback),
    }
  });
  return await request(data);
};

export const updateTargetItemDate = async (id, formdata) => {
  let data = JSON.stringify({
    query: `mutation {
      updateTargetItem(
      id: ${id}, 
      input: {
        date: "${formdata.date}"
      }) {
        success
        message
        output(defaultLanguage: "en") {
          id      
        }
      }
    }`
  });
  return await request(data);
};

export const updateTargetItemUsers = async (id, formdata) => {
  let data = JSON.stringify({
    query: `mutation {
      updateTargetItem(
      id: ${id}, 
      input: {
        User: [{id: ${formdata.User}}]
        User_coop: [{id: ${formdata.User_coop}}]
      }) {
        success
        message
        output(defaultLanguage: "en") {
          id      
        }
      }
    }`
  });
  return await request(data);
};

export const updateTargetItemTarget = async (id, formdata) => {
  let data = JSON.stringify({
    query: `mutation {
      updateTargetItem(
      id: ${id}, 
      input: {
        Target: [{id: ${formdata.Target}}]
      }) {
        success
        message
        output(defaultLanguage: "en") {
          id      
        }
      }
    }`
  });
  return await request(data);
};

export const updatePassword = async (id, formdata) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/update/Credentials/${id}`,
      formdata, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error updating password:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const updateContact = async (id, phone) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/update/Contact/${id}`,
      { phone }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error updating contact:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const updateSelectedCompany = async (id, Company) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/update/User/${id}`,
      { Company }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error updating selected company:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const updateTargetItemUnlocked = async (id, unlocked) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/update/TargetItem/${id}`,
      { unlocked }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error updating target item unlocked status:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const updateTargetItemStatus = async (id, status) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/update/TargetItem/${id}`,
      { status }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error updating target item status:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const updateTargetCard = async (id, formdata) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/update/Target/${id}`,
      formdata, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error updating target card:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};
// #endregion UPDATE API

// #region DELETE API 
export const deleteShiftClosure = async (id) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/core/delete/ShiftClosure/${id}`,
      {}, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });
    return response;
  } catch (error) {
    console.error("Error deleting shift closure:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};
// #endregion DELETE API

// #region CHATBOT API
export const sendMessage = async (master, message) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/chatbot/sendMessage/${master}`,
      { master, message }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error sending message:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};

export const doorbell = async (message) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/chatbot/doorbell`,
      { message }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching doorbell:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};
// #endregion CHATBOT API

// #region PAYSTORE API
export const getPaystore = async (pdv) => {
  const response = await axios.get(`${API_URL}/${API_VERSION}/paystore/get/${pdv}`, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
  });
  return response;
};
// #endregion PAYSTORE API

// #region PDF API
export const getContactList = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/getPDF/contactList`,
      data, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
      responseType: 'blob',
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server: " + error.message, type: "error" };
  }
};

export const getSIM = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/getPDF/sim`,
      data, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
      responseType: 'blob',
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server: " + error.message, type: "error" };
  }
};

export const getList = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/getPDF/contactList`,
      data, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
      responseType: 'blob',
    });

    return response;
  } catch (error) {
    return { message: "Error communicating with the server: " + error.message, type: "error" };
  }
};
// #endregion PDF API

// #region AUTH API
export const get2fa = async (appname, username) => {
  const response = await axios.post(`${API_URL}/${API_VERSION}/2fa/get`, { appname, username }, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
  });
  return response;
};

export const login = async (username, password, otp) => {
  const response = await axios.post(`${API_URL}/${API_VERSION}/login`, { username, password }, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
  });
  return await verify2fa(username, otp) ? response.data : null;
};

export const register = async (username, password) => {
  const response = await axios.post(`${API_URL}/${API_VERSION}/register`, { username, password }, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
  });
  return response.data;
};

export const verify2fa = async (username, otp) => {
  const response = await axios.post(`${API_URL}/${API_VERSION}/2fa/verify`, { username, otp }, {
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
  });
  return response.status === 200 ? true : (console.error("2FA verification failed:", response), false);
};
// #endregion AUTH API

// #region OTHER API
export const getCsv = async (master, date) => {
  try {
    const response = await axios.post(`${API_URL}/${API_VERSION}/ftp/csv/data/${date}/${master}`,
      { myIP }, {
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${API_KEY}`, "x-api-key": API_KEY },
    });

    return response;
  } catch (error) {
    console.error("Error fetching csv:", error);
    return { message: "Error communicating with the server.", type: "error" };
  }
};
// #endregion OTHER API